import BaseLayer from "./BaseLayer";
import {plotStitchGraphHelper, plotStitchGraphStartPositions} from "../utils/map_utils";

class StitchRound2Graphv2 extends BaseLayer {

    id = "stitchRound2Graphv2";
    label = "Path";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPathR2, stitchStartPosR2} = this.props;
        plotStitchGraphStartPositions(stitchStartPosR2, this.props.slide, this.layer.getSource());
        plotStitchGraphHelper(stitchPathR2, this.props.slide, this.layer.getSource());
        resolve();
    });
}

export default StitchRound2Graphv2;
